import { Link } from "react-router-dom";
import { BloodworkBadge } from "./Badges";
import { StartingAtPill } from "./Pricing";
import { ArrowUpRight } from "lucide-react";

export default function TherapyCard({ therapy }) {
  return (
    <article data-testid={`therapy-card-${therapy.slug}`} className="vv-card p-6 flex flex-col gap-4">
      <div>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-2xl leading-tight">{therapy.public_name}</h3>
            {therapy.clinical_name && therapy.clinical_name !== therapy.public_name && (
              <div className="text-xs text-stone-500 mt-1 italic">{therapy.clinical_name}</div>
            )}
          </div>
        </div>
        <p className="text-sm text-stone-600 mt-3 leading-relaxed line-clamp-3">{therapy.short_description}</p>
      </div>

      {!therapy.hide_pricing && (
        <StartingAtPill
          price={therapy.display_monthly_price}
          promo={therapy.promo_price}
          testId={`pricing-card-${therapy.slug}`}
        />
      )}

      <div className="flex flex-wrap gap-1.5">
        <BloodworkBadge level={therapy.bloodwork_level} />
      </div>

      <div className="flex items-center justify-between pt-2 mt-auto border-t border-stone-100">
        <Link
          to={`/peptide-library/${therapy.slug}`}
          data-testid={`therapy-card-learn-${therapy.slug}`}
          className="text-sm font-semibold text-[color:var(--vv-teal)] flex items-center gap-1 hover:gap-2 transition-all"
        >
          Learn more <ArrowUpRight size={14} />
        </Link>
        <Link
          to="/request-consultation"
          data-testid={`therapy-card-consult-${therapy.slug}`}
          className="text-xs font-semibold px-3 py-1.5 rounded-full bg-stone-900 text-white hover:bg-stone-700 transition-colors"
        >
          Consult
        </Link>
      </div>
    </article>
  );
}
